<template>
    <div ref="eyecatcher" class="ave__eyecatcher">
        <div v-for="(line, i) in lines" class="ave__eyecatcher__line" :class="{'ave__eyecatcher__line--current': i === current}">
            {{line}}
        </div>
    </div>
</template>

<script>

export default {
    name: "AveEyecatcher",
    components: {},
    props: {
        lines: Array
    },
    data: function() {
        return {
            current: 0,
            observer: null
        };
    },
    methods: {
        startAnimation: function() {
            this.current = 0;
            setTimeout(this.next, 10000);
            this.observer.unobserve(this.$refs['eyecatcher'])
        },
        next: function() {
            if (this.current + 1 < this.lines.length) {
                this.current += 1;
                setTimeout(this.next, 4000);
            } else {
                this.current = 0;
                setTimeout(this.next, 4000);
            }
        }
    },
    mounted() {
        if (this.$refs['eyecatcher']) {
            this.observer = new IntersectionObserver(this.startAnimation);
            this.observer.observe(this.$refs['eyecatcher']);
        }
    }
}
</script>
